// (c) chaehongee. Confidential and proprietary.

export type { ToolMode } from './useToolMode'

export interface ToolbarProps {
    // State
    brushEnabled: boolean
    toolMode: import('./useToolMode').ToolMode
    selectedCount: number
    readOnly?: boolean

    // Brush props
    canUndo: boolean
    canRedo: boolean
    brushSizeCssPx?: number
    onBrushSizeChange?: (nextCssPx: number) => void
    onUndo: () => void
    onRedo: () => void
    onExitBrush?: () => void

    // Default state props
    onToolModeChange: (mode: import('./useToolMode').ToolMode) => void
    onViewportUndo: () => void
    onViewportRedo: () => void
    canViewportUndo: boolean
    canViewportRedo: boolean
    onAutoLayout?: () => void

    // Selection state props
    onDownload?: () => void
    onSave?: () => void
    onRemove?: () => void

    // Space-held visual
    spacePressed?: boolean
}

export const BRUSH_SIZE_MIN = 8
export const BRUSH_SIZE_MAX = 512
